var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.9884C0 22.3023 2.69767 25 9.01163 25H15.9884C22.3023 25 25 22.3023 25 15.9884V9.01163C25 2.69767 22.3023 0 15.9884 0H9.01163C2.69767 0 0 2.69767 0 9.01163V15.9884Z",
    fill: "#282D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7117 7.67628C17.0434 7.41185 14.3591 7.27563 11.6828 7.27563C10.0963 7.27563 8.50973 7.35576 6.92319 7.51602L5.28857 7.67628",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69531 6.86699L9.87159 5.81731C9.9998 5.05609 10.096 4.48718 11.4501 4.48718H13.5495C14.9036 4.48718 15.0078 5.08814 15.128 5.82532L15.3043 6.86699",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9888 10.2083L17.468 18.2773C17.3798 19.5353 17.3077 20.5128 15.0721 20.5128H9.9279C7.69232 20.5128 7.6202 19.5353 7.53206 18.2773L7.01123 10.2083",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1621 16.1058H13.8304",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4971 12.9006H14.5035",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBg);
export default __webpack_public_path__ + "static/media/trash-bg.205204903263361c7cf589d6f3d7fc15.svg";
export { ForwardRef as ReactComponent };